export const SET_VERIFICATION_CODE="setVerificationCode";
export const SET_IS_LOGIN="setIsLogin";
export const SET_MOBILE_NUMBER="setMobileNumber";
export const SET_IS_AUTHENTICATE="setIsAuthenticate";
export const SET_USER_INFO="setUserInfo";
export const SET_POPUP_LOGIN="setPopupLogin";
export const UPDATE_USER_INFO="updateUserInformation";
export const UPDATE_USER_EMAIL="updateUserEmail";
export const OPEN_MODAL="openLoginModal";
export const CLOSE_MODAL="closeLoginModal";